<div class="d-flex flex-column">
  @if(amount) {
    <div class="d-flex">
      <strong>{{ amount }} {{ currency || '€'}}</strong>
    </div>
    <span class="text-neutral-dark-grey fs-11 fw-400">Par jour</span>
  } @else {
    <div>N/A</div>
  }

  </div>
